<template>
      <v-dialog v-model="open" fullscreen persistent :scrollable="false">
            <v-card>
                  <v-card-title class="bg-title-card">
                        <span class="white--text headline" v-html="obModal.titulo"></span>
                        <v-spacer></v-spacer>
                        <v-icon dark @click="close(false)">close</v-icon>
                  </v-card-title>
                  <v-card-text>
                        <v-container fluid>
                              <v-row dense>
                                    <v-col cols="12" sm="12">
                                          <v-stepper v-model="step" vertical class="removeBorder">
                                          <v-stepper-step step="1" :complete="step > 1"> Datos Principales </v-stepper-step>

                                          <v-stepper-content step="1">
                                                <StepperDatosPrincipalesComponent   :listGeneral="listGeneral" 
                                                                                    :parametros="parametros" 
                                                                                    :obModal="obForm.obPrincipal"/>
                                          </v-stepper-content>

                                          <v-stepper-step step="2" :complete="step > 2"> Documentos </v-stepper-step>

                                          <v-stepper-content step="2">
                                                <StepperDocumentosComponent   :load="step == 2 ? true : false" 
                                                                              :obModal="obForm.obPrincipal"
                                                                              :listDocumento="_.get(obForm,'obDocumentos',{})" 
                                                                              :parametros="parametros"/>
                                          </v-stepper-content>

                                          <v-stepper-step step="3" :complete="step > 3"> Datos De Prima </v-stepper-step>

                                          <v-stepper-content step="3">
                                                <StepperDatosPrimaComponent :load="step == 3 ? true : false" 
                                                                              :obDatosPrincipal="_.get(obForm,'obPrincipal',{})"
                                                                              :obImpuestos="_.get(obForm,'obImpuestos',[])"
                                                                              :obOtros="_.get(obForm,'obOtros',[])"
                                                                              :parametros="parametros"/>
                                          </v-stepper-content>

                                          <v-stepper-step step="4" :complete="step > 4"> Forma de Pago </v-stepper-step>

                                          <v-stepper-content step="4">
                                                <StepperDatosFormaPagoComponent :load="step == 4 ? true : false" 
                                                                                :obDatosPrincipal="_.get(obForm,'obPrincipal',{})"
                                                                                :listTipoFormaPago="_.get(listGeneral,'listTipoFormaPago',[])"
                                                                                :primaTotal="_.toNumber(_.get(_.find(obForm.obPrima,{'tipo_prima':'prima_neta'}),'prima_neta',0))"
                                                                                :parametros="parametros"/>
                                          </v-stepper-content>
                                          </v-stepper>
                                    </v-col>
                              </v-row>
                        </v-container>
                  </v-card-text>
            </v-card>
      </v-dialog>
</template>

<script>
      export default {
            name: 'ModalPolizaTradicionalComponent',
            inject:['close'],
            props:{
                  open:{
                        type:Boolean,
                        default:false
                  },
                  obModal:{
                        type:Object,
                        default:{}
                  },
                  listGeneral:{
                        type:Object,
                        default:{}
                  },
                  parametros:{
                        type:Object,
                        default:{}
                  }
            },
            components:{
                  StepperDatosPrincipalesComponent: () => import('@/components/constructor/polizaTradicional/StepperDatosPrincipalesComponent.vue'),
                  StepperDocumentosComponent: () => import('@/components/constructor/polizaTradicional/StepperDocumentosComponent.vue'),
                  StepperDatosPrimaComponent: () => import('@/components/constructor/polizaTradicional/StepperDatosPrimaComponent.vue'),
                  StepperDatosFormaPagoComponent: () => import('@/components/constructor/polizaTradicional/StepperDatosFormaPagoComponent.vue')
            },
            data: () => ({
                  step: 1,
                  obForm: {
                        obPrincipal:{},
                        obDocumentos:{},
                        obImpuestos:[],
                        obFormaPago:{},
                        obOtros:[],
                        amortizacion:[],
                        obPrima:[]
                  }
            }),
            watch:{
                  open(val){
                        if(val)
                              this.obForm.obPrincipal = this.obModal;
                        else
                              this.clear();
                  }
            },
            methods:{
                  clear(){
                        this.step = 1;
                        this.obForm = {
                                          obPrincipal:{},
                                          obDocumentos:{},
                                          obImpuestos:[],
                                          obFormaPago:{},
                                          obOtros:[],
                                          amortizacion:[],
                                          obPrima:[]
                                    }
                  },
                  setData(keyName,data){
                        _.set(this,keyName,data);
                  },
                  preparateData(){
                        var l = _.filter(_.clone(this.obForm.amortizacion),(v)=>{ return _.isNumber(v.nroCuota)});
                        var ld = _.filter(_.clone(this.obForm.obDocumentos),{'new':true});
                        var amortizacion = _.map(l,_.partialRight(_.omit,['edit','index','mod']));
                        var keys = [
                                    'idContratante','idAseguradora','idSeguro','idPoliza','poliza',
                                    'idCliente','idCertificado','valorAsegurado','idSecPrima','idSecPrima',
                                    'fechaVigenciaDesde','fechaVigenciaHasta','idSecFormaPagoCab'
                                    ];

                        return {
                              obPrincipal  : _.pick(this.obForm.obPrincipal,keys),
                              obDocumentos : _.map(ld,_.partialRight(_.pick,['id','base','nameFile'])),
                              obImpuestos  : _.map(this.obForm.obImpuestos,_.partialRight(_.omit,['nombre'])),
                              obOtros      : _.map(this.obForm.obOtros,_.partialRight(_.omit,['nombre'])),
                              obFormaPago  : this.obForm.obFormaPago,
                              amortizacion : _.map(amortizacion,(v)=>{ v.fechaVencimiento = _.size(v.fechaVencimiento) == 0 ? moment().format('YYYY-MM-DD') : moment(v.fechaVencimiento,'YYYY-MM-DD').format('YYYY-MM-DD'); return v; }),
                              obPrima      : this.obForm.obPrima
                        };
                  },
                  insertar(){
                        var o = this.preparateData();
                        console.info(o)
                        var url = _.isUndefined(o.obPrincipal.idCertificado) || _.isNull(o.obPrincipal.idCertificado) ? 'administrador/poliza-tradicional/insertar' : 'administrador/poliza-tradicional/actualizar';

                        return axios.post(`${BASE_URI}${url}`,o)
                                    .then((r)=>{
                                          if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                                mensajeAlertaTiempo(r.data.mensaje,'S');

                                                setTimeout(() => {
                                                window.location.reload();
                                                }, 5000);
                                          return true;
                                    })
                                    .catch((e)=>{
                                          mensajesAlerta(e,'E');
                                          return false;
                                    });
                  }
            },
            provide(){
                  return{
                        setData:this.setData,
                        insertar:this.insertar
                  }
            }
      }
</script>

<style scoped>
    .removeBorder {
        box-shadow: none !important;
    } 
    .theme--dark.v-stepper{
        background: none !important;
    }
</style>